import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class PendingValidationBanner extends Component {
  view() {
    return (
      <div className="PendingValidationBanner">
        <div className="container">
          <i className="fas fa-clock"></i>
          {' '}
          {app.translator.trans('florcarioca-rsvp.forum.pending_validation.message')}
        </div>
      </div>
    );
  }
}
